import { useState } from 'react'
import { KeyRound, Loader2, Check } from 'lucide-react'
import { changePassword } from '../../api/auth'

const champ = 'w-full rounded-xl border border-navy/15 bg-white px-3.5 py-2.5 text-sm outline-none focus:border-orange'
const label = 'mb-1.5 block text-xs font-semibold uppercase tracking-wide text-ink/55'

export function AdminCompte() {
  const [actuel, setActuel] = useState('')
  const [nouveau, setNouveau] = useState('')
  const [confirme, setConfirme] = useState('')
  const [busy, setBusy] = useState(false)
  const [ok, setOk] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setOk(false)
    if (nouveau.length < 6) {
      setError('Le nouveau mot de passe doit faire au moins 6 caractères.')
      return
    }
    if (nouveau !== confirme) {
      setError('Les deux nouveaux mots de passe ne correspondent pas.')
      return
    }
    setBusy(true)
    try {
      await changePassword(actuel, nouveau)
      setOk(true)
      setActuel(''); setNouveau(''); setConfirme('')
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Une erreur est survenue.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="max-w-md">
      <div className="flex items-center gap-3">
        <span className="grid h-11 w-11 place-items-center rounded-xl bg-navy/10 text-navy">
          <KeyRound className="h-5 w-5" />
        </span>
        <div>
          <h2 className="font-display text-lg font-bold text-navy-dk">Changer mon mot de passe</h2>
          <p className="text-sm text-ink/55">Saisissez votre mot de passe actuel puis le nouveau.</p>
        </div>
      </div>

      <form onSubmit={submit} className="mt-6 space-y-4">
        <div>
          <label htmlFor="pw-actuel" className={label}>Mot de passe actuel</label>
          <input id="pw-actuel" type="password" autoComplete="current-password" value={actuel} onChange={(e) => setActuel(e.target.value)} className={champ} />
        </div>
        <div>
          <label htmlFor="pw-nouveau" className={label}>Nouveau mot de passe</label>
          <input id="pw-nouveau" type="password" autoComplete="new-password" value={nouveau} onChange={(e) => setNouveau(e.target.value)} className={champ} />
        </div>
        <div>
          <label htmlFor="pw-confirme" className={label}>Confirmer le nouveau mot de passe</label>
          <input id="pw-confirme" type="password" autoComplete="new-password" value={confirme} onChange={(e) => setConfirme(e.target.value)} className={champ} />
        </div>

        {error && <div className="rounded-lg bg-orange/10 px-3 py-2 text-sm text-orange-dk">{error}</div>}
        {ok && (
          <div className="inline-flex items-center gap-1.5 rounded-lg bg-green-50 px-3 py-2 text-sm font-medium text-green-700">
            <Check className="h-4 w-4" /> Mot de passe modifié avec succès.
          </div>
        )}

        <button
          disabled={busy || !actuel || !nouveau || !confirme}
          className="inline-flex items-center gap-2 rounded-full bg-navy px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-navy-dk disabled:opacity-50"
        >
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />}
          Enregistrer le nouveau mot de passe
        </button>
      </form>
    </div>
  )
}
